import styles from "./pause-button.module.css";

const togglePauseStory = async (action, isPaused) => {
    await new Promise((resolve) => setTimeout(() => {
        action(isPaused ? 'play' : 'pause');
        resolve();
    }, 100));
}

export const PauseButton = ({ action, isPaused }) => {
    return (
        <button
            onClick={() => togglePauseStory(action, isPaused)}
            className={styles.container}
        >
            {isPaused ?
                <div className={styles.play}></div>
                :
                <>
                    <div className={styles.pause}></div>
                    <div className={styles.pause}></div>
                </>
            }
        </button>
    )
}